<template>
    <!-- <div class="container">
    <Header msg="FUCHSIA VINE DESIGNS PRIVATE LIMITED" />
    <div class="middlecontainer">
      <LeftMenu /> -->

      <div class="advancedReportsContainer">
        <!-- <SaveAndScheduleReport :advancedReport="true"/> -->
      </div>

    <!-- </div> -->
</template>

<script> 
    import Header from './Header.vue'
    import LeftMenu from './LeftMenu.vue'
    import SaveAndScheduleReport from './SaveAndScheduleReport.vue'
    import { mapActions } from "vuex";
import { getCookie } from '@/services/campaignService';

    export default {
        name: 'AdvancedReports',
        components: {
            Header,
            LeftMenu,
            SaveAndScheduleReport
        },
        data() {
            return {
                title: 'Advanced Reports',
                reportData : [
                    {
                        name: 'Scheduled report type',
                        startDate: 'Start date',
                        endDate: 'End date',
                        frequency: 'Frequency',
                        emailIds: 'Email ids',
                    },
                    {
                        name: 'Sample Name',
                        startDate: 'Dec 5, 2022',
                        endDate: 'Dec 5, 2022',
                        frequency: 'Weekly',
                        emailIds: 'Sampleidname@xyz.com',
                    },
                    {
                        name: 'Sample Name',
                        startDate: 'Dec 5, 2022',
                        endDate: 'Dec 5, 2022',
                        frequency: 'Weekly',
                        emailIds: 'Sampleidname@xyz.com',
                    },
                    {
                        name: 'Sample Name',
                        startDate: 'Dec 5, 2022',
                        endDate: 'Dec 5, 2022',
                        frequency: 'Weekly',
                        emailIds: 'Sampleidname@xyz.com',
                    },
                    {
                        name: 'Sample Name',
                        startDate: 'Dec 5, 2022',
                        endDate: 'Dec 5, 2022',
                        frequency: 'Weekly',
                        emailIds: 'Sampleidname@xyz.com',
                    },
                    {
                        name: 'Sample Name',
                        startDate: 'Dec 5, 2022',
                        endDate: 'Dec 5, 2022',
                        frequency: 'Weekly',
                        emailIds: 'Sampleidname@xyz.com',
                    }
                ]
            }
        },
        methods: {
            ...mapActions(['setAdvanceReportBool']),
            onBackBtnClick(){
                const role = getCookie('role');
                this.$router.push(`${role === 'SUPERADMIN' || role === 'OPS' ? '/admin' : ''}/campaigns`)
            },
            onSaveAndScheduleReport(){
                const role = getCookie('role');
                //localStorage.setItem('setAdvanceReportBool', true)
                this.setAdvanceReportBool(true)
                this.$router.push(`${role === 'SUPERADMIN' || role === 'OPS' ? '/admin' : ''}/save-schedule-report`)
            }
        },
        mounted() {
            this.onSaveAndScheduleReport()
            this.setAdvanceReportBool(true)
            //localStorage.setItem('setAdvanceReportBool', true)
        }
    }
</script>

<style scoped>
    @font-face {
        font-family: "Inter-Regular";
        src: url('../assets/fonts/Inter-Regular.ttf');
    }

    .date{
        margin-left: 40px;
    }

    .deleteIcon{
        margin: 0 30px;
    }
    .headerRow{
        display: flex;
        justify-content: space-between;
        padding: 22px 68px 22px 26px;
        background: #F7F7F7;
        border-radius: 4px;
    }

    .rowItem{
        display: grid;
        grid-template-columns: auto auto auto auto auto auto;
        justify-content: space-between;
        padding: 12px 20px 12px 50px;
    }

    .item{
        font-family: 'Inter-Regular';
        font-style: normal;
        font-weight: 500;
        font-size: 11.269px;
        line-height: 22px;
        color: #41434C;
        opacity: 0.8;
    }

    .rows{
        /* display: grid;
        grid-template-columns: auto auto auto auto auto auto; */
        /* max-width: 1146px; */
        margin: 0 24px 20px;
        background: #FFFFFF;
        padding: 12px;
        border-radius: 4px;
        height: 100vh;
    }

    .rowtitle{
        font-family: 'Inter-Regular';
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 130%;
        color: #141414;
    }

    .advancedReportsContainer{
        width: 100%;
        background: #F8F8F8;
    }

    .middlecontainer{
        font-family: 'Inter-Regular';
        display: flex;
        flex-direction: row;
        width: 100%;
    }
    .titleWrapper{
        display: flex;
        align-items: center;
        max-width: 300px;
    }

    .arrow{
        margin-right: 15px;
        width: 18px;
        height: 14px;
        cursor: pointer;
    }
    .headerWrapper{
        display: flex;
        justify-content: space-between;
        padding: 24px 30px 20px 14px;
        margin-bottom: 22px;
        background: #FFFFFF;

    }

    .title{
        font-family: 'Inter-Regular';
        font-style: normal;
        font-weight: 600;
        font-size: 24px;
        line-height: 140%;
        color: #373737;
    }

    .saveBtn{
        font-family: 'Inter-Regular';
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 23px;
        color: #0004B5;
        opacity: 0.8;
        padding: 6px 20px;
        border: 1px solid #2E31BE;
        border-radius: 4px;
        cursor: pointer;
    }
</style>